<template>
  <div class="block-center mt-4 wd-xxl">
    <div class="text-center mt-4 mb-4">
      <a href="../" title="TLT"> <img src="/static/logo.png" alt="TLT logo" class="tbt-logo"></a>
    </div>
    <div class="card card-flat">
      <div class="card-header text-center bg-dark-green">
<!--        <h4 class="text-white">{{ $t('maintainance-text') }}</h4>-->
        <h4 class="text-white m-0">{{ $t('global.client-name') }}</h4>
      </div>
      <div class="card-body">
        <h4 class="text-center py-2">{{ $t('global.tender-system') }}</h4>
        <div role="tabpanel">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" role="presentation">
              <a aria-controls="idCard" class="nav-link active" data-toggle="tab" href="#idCard"
                 role="tab">{{ $t('login.id-card') }}</a>
            </li>
            <li class="nav-item" role="presentation">
              <a aria-controls="mobleId" class="nav-link" data-toggle="tab" href="#mobleId" role="tab">{{
                  $t('login.mobile-id')
                }}</a>
            </li>
            <li class="nav-item" role="presentation">
              <a aria-controls="smartId" class="nav-link" data-toggle="tab" href="#smartId" role="tab">{{
                  $t('login.smart-id')
                }}</a>
            </li>
            <li class="nav-item" role="presentation">
              <a aria-controls="emailLogin" class="nav-link" data-toggle="tab" href="#emailLogin"
                 role="tab">{{ $t('login.email') }}</a>
            </li>
          </ul>

          <div class="tab-content">

            <div class="tab-pane active" id="idCard" role="tabpanel">
              <div v-if="error">
                <div class="alert alert-danger bg-danger-light text-center" role="alert">
                  <i class="fa fa-exclamation-triangle"></i> {{ error }}
                </div>
              </div>
              <p>{{ $t('login.id-card-text') }}</p>
              <button class="btn btn-success" @click="login_id">{{ $t('login.login') }}</button>
            </div>

            <div class="tab-pane" id="mobleId" role="tabpanel">

              <div v-if="error">
                <div class="alert alert-danger bg-danger-light text-center" role="alert">
                  <i class="fa fa-exclamation-triangle"></i> {{ error }}
                </div>
              </div>

              <div class="mb-2">
                <form @submit.prevent="login_mobile" class="form-modal form-login" v-if="!is_challenge">
                  <p>{{ $t('login.mobile-id') }}</p>
                  <div class="form-group">
                    <div class="input-group with-focus">
                      <input
                        v-model="personal_code"
                        :disabled="timer > 0"
                        :class="{'parsley-error': errors.personal_code}"
                        id="personal_code_mobile"
                        autocomplete="off"
                        class="form-control"
                        :placeholder="$t('login.personal-code')"
                        type="text"
                        required>
                    </div>
                    <ul class="parsley-errors-list filled" v-if="errors.personal_code">
                      <li class="parsley-required">{{ errors.personal_code[0] }}</li>
                    </ul>
                  </div>

                  <div class="form-group">
                    <div class="input-group with-focus">
                      <input
                        v-model="phone"
                        :disabled="timer > 0"
                        :class="{'parsley-error': errors.phone}"
                        id="phone"
                        autocomplete="off"
                        class="form-control"
                        :placeholder="$t('login.mobile')"
                        type="text"
                        required>
                    </div>
                    <ul class="parsley-errors-list filled" v-if="errors.phone">
                      <li class="parsley-required">{{ errors.phone[0] }}</li>
                    </ul>
                  </div>
                  <button class="btn btn-success">{{ $t('login.login') }}</button>
                </form>
              </div>

              <div>
                <div class="alert bg-gray-lighter" role="alert" v-if="is_challenge">
                  <p>{{ $t('login.challenge-code') }}: </p>
                  <h3>{{ challenge }}</h3>
                  <p>{{ $t('login.waiting-mobile') }}... {{ timer }} {{ $t('login.seconds') }}</p>
                  <button class="btn btn-sm btn-outline-danger" @click="cancel_mobile">{{
                      $t('login.cancel')
                    }}
                  </button>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="smartId" role="tabpanel">
              <div v-if="error">
                <div class="alert alert-danger bg-danger-light text-center" role="alert">
                  <i class="fa fa-exclamation-triangle"></i> {{ error }}
                </div>
              </div>
              <div class="mb-2">
                <form @submit.prevent="login_smart" class="form-modal form-login" v-if="!is_challenge">
                  <p>{{ $t('login.smart-id') }}</p>
                  <div class="form-group">
                    <div class="input-group with-focus">
                      <input
                        v-model="personal_code"
                        :disabled="timer > 0"
                        :class="{'parsley-error': errors.personal_code}"
                        id="personal_code_smart"
                        autocomplete="off"
                        class="form-control"
                        :placeholder="$t('login.personal-code')"
                        type="text"
                        required>
                    </div>
                    <ul class="parsley-errors-list filled" v-if="errors.personal_code">
                      <li class="parsley-required">{{ errors.personal_code[0] }}</li>
                    </ul>
                  </div>
                  <button class="btn btn-success">{{ $t('login.login') }}</button>
                </form>
              </div>

              <div>
                <div class="alert bg-gray-lighter" role="alert" v-if="is_challenge">
                  <p>{{ $t('login.challenge-code') }}: </p>
                  <h3>{{ challenge }}</h3>
                  <p>{{ $t('login.waiting-smart-id') }}... {{ timer }} {{ $t('login.seconds') }}</p>
                  <button class="btn btn-sm btn-outline-danger" @click="cancel_smart">{{
                      $t('login.cancel')
                    }}
                  </button>
                </div>
              </div>
            </div>

            <div class="tab-pane" id="emailLogin" role="tabpanel">
              <form @submit.prevent="login" class="form-modal form-login">
                <p>{{ $t('login.email') }}</p>
                <div class="form-group">
                  <div class="input-group with-focus">
                    <input
                      v-model="email"
                      :class="{'parsley-error': errors.email}"
                      id="email"
                      autocomplete="off"
                      class="form-control"
                      :placeholder="$t('login.email')"
                      type="text"
                      required>
                  </div>
                  <ul class="parsley-errors-list filled" v-if="errors.email">
                    <li class="parsley-required">{{ errors.email[0] }}</li>
                  </ul>
                </div>

                <div class="form-group">
                  <div class="input-group with-focus">
                    <input
                      v-model="password"
                      :class="{'parsley-error': errors.password}"
                      id="password"
                      autocomplete="off"
                      class="form-control"
                      :placeholder="$t('login.password')"
                      type="password"
                      required>
                  </div>
                  <ul class="parsley-errors-list filled" v-if="errors.password">
                    <li class="parsley-required">{{ errors.password[0] }}</li>
                  </ul>
                </div>
                <div class="clearfix">
                  <div class="float-right">
                    <router-link :to="{name: 'recover'}" class="text-muted">{{
                        $t('login.recover')
                      }}
                    </router-link>
                  </div>
                </div>
                <button class="btn btn-success">{{ $t('login.login') }}</button>
              </form>
            </div>
          </div>
        </div>
        <p class="pt-3 text-center">{{ $t('login.register') }}</p>
        <router-link :to="{name: 'register'}" class="btn btn-block btn-secondary">
          {{ $t('login.registration') }}
        </router-link>
      </div>
    </div>
    <div class="spacer pt-20"></div>
    <div class="container">
      <div class="row">
        <div class="col-8">
          <span>{{ $t('global.soft-year') }} {{ $t('global.soft-name') }}</span>
        </div>
        <div class="col text-right login-lang-select">
          <li class="nav-item dropdown dropdown-list">
            <a
              class="dropdown-toggle
            dropdown-toggle-nocaret
            align-middle"
              data-toggle="dropdown"
              v-if="language==='et-EE'"
            >
              <img src="/static/et.png" height="14" alt="Eesti" title="Eesti"> Eesti
            </a>
            <a
              class="dropdown-toggle
            dropdown-toggle-nocaret
            align-middle"
              data-toggle="dropdown"
              v-if="language==='ru-RU'"
            >
              <img src="/static/ru.png" height="14" alt="Русский" title="Русский"> Русский
            </a>
            <a
              class="dropdown-toggle
            dropdown-toggle-nocaret
            align-middle"
              data-toggle="dropdown"
              v-if="language==='en-US'"
            >
              <img src="/static/en.png" height="14" alt="English" title="English"> English
            </a>

            <div class="dropdown-menu animated flipInX">
              <div class="dropdown-item">
                <div class="list-group">

                  <div class="list-group-item list-group-item-action" v-if="language!=='et-EE'"
                       @click="set_language('et-EE')">
                    <div class="media">
                      <div class="media-body">
                        <a class="m-0 link-unstyled align-middle">
                          <img src="/static/et.png" height="14" alt="Eesti" title="Eesti"> Eesti
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="list-group-item list-group-item-action" v-if="language!=='ru-RU'"
                       @click="set_language('ru-RU')">
                    <div class="media">
                      <div class="media-body">
                        <a class="m-0 link-unstyled align-middle">
                          <img src="/static/ru.png" height="14" alt="Русский" title="Русский">
                          Русский
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="list-group-item list-group-item-action" v-if="language!=='en-US'"
                       @click="set_language('en-US')">
                    <div class="media">
                      <div class="media-body">
                        <a class="m-0 link-unstyled align-middle">
                          <img src="/static/en.png" height="14" alt="English" title="English"
                               class=""> English</a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </li>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api'
import message from '@/message'
import {parseApiError} from '@/utils'

export default {
  data() {
    return {
      language: this.$store.getters.language,
      personal_code: null,
      phone: null,
      email: null,
      password: null,
      errors: {},
      timer: null,
      challenge: null,
      interval: null,
      error: null,
      auth_id: null
    }
  },
  computed: {
    is_challenge() {
      return this.challenge !== null
    }
  },
  mounted() {
    this.$i18n.locale = this.$store.getters.language

    if (localStorage.getItem('etend.language') == null) {
      this.set_language('et-EE')

    } else {
      this.set_language(localStorage.getItem('etend.language'))
    }
  },
  methods: {
    set_language(lang) {
      this.$store.dispatch('setLanguage', lang)
      this.language = lang
      this.$i18n.locale = lang
    },
    login() {
      this.errors = {}
      api.post('/login/', {
        email: this.email,
        password: this.password
      })
        .then(resp => {
          localStorage.setItem('etend.role', resp.data.user.role);
          this.$store.commit('log_in', resp.data)
          this.$i18n.locale = this.$store.getters.language

          let route = sessionStorage.getItem('previous_route')
          if (['/', '/register', undefined].includes(route)) {
            route = 'tenders'
          }
          this.$router.replace(route)

            localStorage.setItem('etend.firstSelect', false);
            if (localStorage.selectedDivision == null) {
              localStorage.selectedDivision = resp.data.user.supplier_group
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 400) {
              this.errors = parseApiError(error, this.$i18n)
              if (this.errors.detail) {
                message.error(this.errors.detail)
              }
            } else if (error.response && [403, 429].includes(error.response.status)) {
              if (error.response.data.detail) {
                message.error(error.response.data.detail)
              }
            } else {
              message.error(error.response)
            }
          })
    },
    clear_data() {
      clearInterval(this.interval)
      this.timer = null
      this.challenge = null
      this.error = null
    },
    cancel_mobile() {
      api.get('/login_mobile_cancel/', {
        params: {
          'auth_id': this.auth_id
        }
      })
      this.clear_data()
    },
    check_mobile_status() {
      this.timer = this.timer - 1
      api.get('/login_mobile_status/', {
        params: {
          'auth_id': this.auth_id
        }
      })
        .then(resp => {
          if (resp.data.challenge) {
            this.challenge = resp.data.challenge
          }
          if (resp.data.status === 'USER_AUTHENTICATED') {
            this.clear_data()
            this.$store.commit('log_in', resp.data)
            this.$i18n.locale = this.$store.getters.language
            this.$router.push({name: 'tenders'})
            localStorage.setItem('etend.role', resp.data.user.role);
            localStorage.setItem('etend.firstSelect', false);
            if (localStorage.selectedDivision == null) {
              localStorage.selectedDivision = resp.data.user.supplier_group
            }
          } else if (resp.data.status !== 'OUTSTANDING_TRANSACTION') {
            this.cancel_mobile()
            this.error = resp.data.status_description
          }
        })
      if (this.timer === 0) {
        this.cancel_mobile()
      }
    },
    login_mobile() {
      this.errors = {}
      this.error = null
      if (this.phone.charAt(0) !== '+') {
        this.phone = '+' + this.phone
      }
      if (this.phone.substring(0, 4) !== '+372') {
        this.phone = '+372' + this.phone.substring(1)
      }
      api.post('/login_mobile_init/', {
        personal_code: this.personal_code,
        phone: this.phone
      })
        .then(resp => {
          this.timer = 90
          this.auth_id = resp.data.auth_id
          this.interval = setInterval(this.check_mobile_status, 1000)
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            this.errors = parseApiError(error, this.$i18n)
            if (this.errors.detail) {
              this.error = this.errors.detail
            }
          } else {
            message.error(error.response)
          }
        })
    },
    cancel_smart() {
      this.clear_data()
      api.get('/login_smart_cancel/', {
        params: {
          'auth_id': this.auth_id
        }
      })
    },
    check_smart_status() {
      this.timer = this.timer - 1
      api.get('/login_smart_status/', {
        params: {
          'auth_id': this.auth_id
        }
      })
        .then(resp => {
          if (resp.data.challenge) {
            this.challenge = resp.data.challenge
          }
          if (resp.data.status === 'USER_AUTHENTICATED') {
            this.clear_data()
            this.$store.commit('log_in', resp.data)
            this.$i18n.locale = this.$store.getters.language
            this.$router.push({name: 'tenders'})
            localStorage.setItem('etend.role', resp.data.user.role);

            localStorage.setItem('etend.firstSelect', false);
            if (localStorage.selectedDivision == null) {
              localStorage.selectedDivision = resp.data.user.supplier_group
            }
          } else if (resp.data.status !== 'OUTSTANDING_TRANSACTION') {
            this.cancel_smart()
            this.error = resp.data.status_description
          }
        })
      if (this.timer === 0) {
        this.cancel_smart()
      }
    },
    login_smart() {
      this.errors = {}
      api.post('/login_smart_init/', {
        personal_code: this.personal_code
      })
        .then(resp => {
          this.timer = 90
          this.auth_id = resp.data.auth_id
          this.interval = setInterval(this.check_smart_status, 1000)
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            this.errors = parseApiError(error, this.$i18n)
            if (this.errors.detail) {
              this.error = this.errors.detail
            }
          } else {
            message.error(error.response)
          }
        })
    },
    login_id() {
      fetch(`${process.env.ID_URL}api/login_id/`, {
        method: 'post',
        headers: {
          // for Firefox CORS
          "Content-Type": "text/plain"
        },
        mode: 'cors',
        credentials: 'include',
        cache: 'default'
      })
        .then(response => response.json())
        .then(resp => {
          this.$store.commit('log_in', resp)
          this.$i18n.locale = this.$store.getters.language
          this.$router.push({name: 'tenders'})
          localStorage.setItem('etend.role', resp.user.role);

          localStorage.setItem('etend.firstSelect', false);
          if (localStorage.selectedDivision == null) {
            localStorage.selectedDivision = resp.user.supplier_group
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 400) {
            this.errors = parseApiError(error, this.$i18n)
            if (this.errors.detail) {
              this.error = this.errors.detail
            }
          } else {
            message.error(error.response)
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue